export const CylinderProgress = ({
  label,
  value,
  target,
  actualTitle,
  targetTitle,
  per,
}) => {
  let percentage = Math.min((value / target) * 100, 100);

  // Determine color based on percentage
  let fillColor = "";

  if (per === " < 35") {
    fillColor = "#ff5555";
    percentage = 100;
  } else if (percentage < 35) {
    fillColor = "#ff5555"; // red
  } else if (percentage < 100) {
    fillColor = "#ff9348"; // orange
  } else {
    fillColor = "#22C55E"; // green
  }
  const baseGradient = "#f3f4f6"; // light gray background

  return (
    <div
      className={`mb-[7px] flex items-center gap-2 border-l-4 p-2`}
      style={{ borderLeftColor: fillColor }}
    >
      <div className="text-xs font-[400] text-gray-700 mb-1 w-2/3">{label}</div>

      <div className="relative w-full h-4 rounded-full overflow-hidden">
        <div
          className="w-full h-full rounded-full shadow-inner"
          style={{ backgroundColor: baseGradient }}
        />
        <div
          className="absolute top-0 left-0 h-full rounded-full shadow-[inset_-2px_2px_4px_rgba(0,0,0,0.2)]"
          style={{
            width: `${percentage}%`,
            backgroundColor: fillColor,
          }}
          title={actualTitle}
        />

        <div className="absolute inset-0 rounded-full bg-white opacity-10 pointer-events-none" />
        <div className="absolute top-0 left-0 w-full h-full flex justify-between items-center px-3 text-xs font-bold text-gray-700 cursor-pointer">
          <span
            className="text-gray-700"
            title={actualTitle}
            style={{
              width: `${percentage}%`,
            }}
          >
            {value}
          </span>
          <span title={targetTitle}>{target}</span>
        </div>
      </div>
    </div>
  );
};

export default CylinderProgress;
